import { render, staticRenderFns } from "./KD1Config.vue?vue&type=template&id=51166d6e&scoped=true"
import script from "./KD1Config.vue?vue&type=script&lang=js"
export * from "./KD1Config.vue?vue&type=script&lang=js"
import style0 from "./KD1Config.vue?vue&type=style&index=0&id=51166d6e&prod&lang=css"
import style1 from "./KD1Config.vue?vue&type=style&index=1&id=51166d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51166d6e",
  null
  
)

export default component.exports